import { Filter, FilterData } from "./filter";

export interface PaginationFilterProps {
    type: "pagination",
    pageName?: string,
    pageSizeName?: string,
    initialPage?: number,
    initialPageSize?: number
}

export interface PaginationFilterReturn {
    type: "pagination",
    key: string,
    active: boolean,
    page: number,
    pageSize: number,
    pageActive: boolean,
    pageSizeActive: boolean,
    pageName: string,
    pageSizeName: string,
    initialPage: number,
    initialPageSize: number,
    getCriteria:()=>string;
}

export class PaginationFilter extends Filter {
    pageName: string;
    pageSizeName: string;
    initialPage: number;
    initialPageSize: number;

    constructor({ pageName = "page", pageSizeName = "pageSize", initialPage = 0, initialPageSize = 25 }: PaginationFilterProps) {
        super();
        this.pageName = pageName;
        this.pageSizeName = pageSizeName;
        this.initialPage = initialPage;
        this.initialPageSize = initialPageSize;
    }

    public getInitialValues(result: FilterData): void {
        result[this.pageName] = this.initialPage;
        result[this.pageSizeName] = this.initialPageSize;
    }

    public getFilter(filterData: FilterData): PaginationFilterReturn {
        const page = this.getPage(filterData);
        const pageSize = this.getPageSize(filterData);
        const pageActive = page !== this.initialPage;
        const pageSizeActive = pageSize !== this.initialPageSize;

        return {
            type: "pagination",
            key: `${this.pageName}-${this.pageSizeName}`,
            page: page,
            pageSize: pageSize,
            active: pageActive || pageSizeActive,
            pageActive: pageActive,
            pageSizeActive: pageSizeActive,
            pageName: this.pageName,
            pageSizeName: this.pageSizeName,
            initialPage: this.initialPage,
            initialPageSize: this.initialPageSize,
            getCriteria: ()=>this.getCriteria(filterData)
        };
    }

    public parse(filterData: FilterData, result: FilterData): void {
        const page = this.getPage(filterData);
        const pageSize = this.getPageSize(filterData);

        if (page !== this.initialPage) result[this.pageName] = page;
        if (pageSize !== this.initialPageSize) result[this.pageSizeName] = pageSize;
    }

    public getCriteria(_: FilterData): string {
        return "";
    }

    private getPage(filterData: FilterData): number {
        return parseFloat(String(filterData[this.pageName] || this.initialPage));
    }

    private getPageSize(filterData: FilterData): number {
        return parseFloat(String(filterData[this.pageSizeName] || this.initialPageSize));
    }
}